import { useCallback } from 'react';
import { bridge } from 'shared/src/utils';

export const useLogCompleteRemoveGoods = () => {
  return useCallback(() => {
    bridge.logAnalyticsEvent({
      name: 'COMPLETE_REMOVE_GOODS',
      analytics: {
        SCREEN: 'LIKED_GOODS_EDIT',
      },
    });
  }, []);
};
